<div class="content-container">
    <span *ngIf="message" [innerHTML]="message | safeHtml"></span>
    <button type="button" class="button-secondary" (click)="remove()">
        <dtm-ui-icon name="close" />
        {{ "dtmUi.customCloseButtonToastButtonLabel" | transloco }}
    </button>
</div>
